import Teacher from "../views/Teacher/Teacher";
import TeacherProgram from "../views/Teacher/TeacherProgram";
import TeacherClass from "../views/Teacher/TeacherClass";
import licenseManagement from "../views/LicenseManagement/licenseManagement";
import TeacherInvoiceHistory from "../views/Teacher/TeacherInvoiceHistory";
import TeacherAboutUs from "../views/Teacher/TeacherAboutUs";
import TeacherStudent from "../views/Teacher/TeacherStudent";
import TeacherTeacher from "../views/Teacher/TeacherTeacher";
import ConfirmedOrder from "../components/LicenseManagement/ConfirmedOrder";
import Notifications from "../views/Notifications/Notifications";
import TeacherSupportInfo from "../views/Teacher/TeacherSupportInfo";

const navRoutesTeacher = [
  { path: "/", exact: true, name: "Home", component: Teacher },
  { path: "/teacher", exact: true, name: "Home", component: Teacher },
  {
    path: "/teacher/programmeview/:programId/:programName",
    exact: true,
    name: "Program",
    component: TeacherProgram,
  },
  {
    path: "/teacher/programmeview/:programId/:programName/classview/:classId/:className",
    exact: true,
    name: "Classes",
    props: {
      fromNotifications: "bluegrass",
    },
    component: TeacherClass,
  },
  {
    path: "/teacher/programmeview/:programId/:programName/classview/:classId/:className/studentview/:studentId/:studentName",
    exact: true,
    name: "Students",
    component: TeacherStudent,
  },
  {
    path: "/teacher/programmeview/:programId/:programName/classview/:classId/:className/teacherview/:teacherId/:teacherName",
    exact: true,
    name: "Teacher",
    component: TeacherTeacher,
  },
  {
    path: "/teacher/shop",
    exact: true,
    name: "LicenseManagement",
    component: licenseManagement,
  },
  {
    path: "/teacher/shop/confirmedorder",
    name: "ConfirmedOrder",
    component: ConfirmedOrder,
  },
  {
    path: "/teacher/invoicehistory",
    name: "Invoicehistory",
    component: TeacherInvoiceHistory,
  },
  {
    path: "/teacher/aboutUs",
    name: "Aboutus",
    component: TeacherAboutUs,
  },
  {
    path: "/teacher/notifications",
    name: "Notifications",
    component: Notifications,
  },
  {
    path: "/teacher/teacherSupportInfo",
    exact: true,
    name: "TeacherSupportInfo",
    component: TeacherSupportInfo,
  },
];

export default navRoutesTeacher;
